import QRCodeGenerator from 'qrcode.react';
import { MoonLoader } from 'react-spinners'


class AuthenticatorEnrollment extends waffle.base.BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      checkingAuthStatus: true,
      enrolling: false,
      enrolled: false,
      verified: false,
      flashEnrolled: false,
      qrCodeURI: ''
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextState.flashEnrolled && nextState.qrCodeURI === '') {
      this.getQRCodeURI();
    }
  }

  componentWillMount() {
    this.checkGAuthStatus();
  }

  checkGAuthStatus() {
    $.get('/api/account/authenticatorStatus', (data) => {
      this.setState({
        enrolled: data.data.isRegistered,
        verified: data.data.isVerified,
        checkingAuthStatus: false,
        manualRegistration: false
      });
    })
  }

  authenticatorVerified() {
    this.props.nextTarget && this.props.nextTarget.trim() ? window.location.href = this.props.nextTarget : this.checkGAuthStatus()
  }

  getQRCodeURI() {
    $.get('/api/account/authenticatorQrCodeUri', (data) => {
      if (data.data['qrcode-uri']) {
        this.setState({qrCodeURI: data.data['qrcode-uri']})
      }
    })
  }

  renderEnrollButton() {
    return (
      <div className='enroll'>
        <p>You need to have the 2 factor authenticator app of your choice. e.g. Google authenticator</p>
        <p>Click the enroll button below when you have the app downloaded to your device and ready for enrollment</p>

        <waffle.buttons.ApiButton
          label='Enroll Now'
          className='flat-button blue-background'
          api="/api/account/authenticatorRegister"
          onSuccess={() => setTimeout(() => this.setState({flashEnrolled: true}), 500)} // use a timeout to avoid getting an error `setState() on an unmounted component`
          onFailure={(result) => console.error(result)}
        />
      </div>
    )
  }

  renderQrCode() {
    if (!this.state.qrCodeURI) {
      return this.renderErrorMessage();
    }

    try {
      if (this.state.manualRegistration) {
        var a = document.createElement('a');
        // otpauth://totp/<email>?issuer=<issuer>&secret=<key>
        a.href = this.state.qrCodeURI;

        //?issuer=<issuer>&secret=<key> => {issuer:<issuer>,secret:<key>} in any order
        const paramsObject = JSON.parse(`${decodeURI(a.search).split('=').join('":"').split('&').join('","').replace('?', '{"')}"}`);

        //totp/Yoco%20Admin:email@yoco.co.za => Yoco Admin:email@yoco.co.za
        const email = decodeURI(a.pathname.split('/').slice(-1)[0]);

        const issuer = paramsObject.issuer || 'Yoco Admin';
        const key = paramsObject.secret;

        return (
          <div>
            <label>Manually enrollment</label>
            <p>Launch authenticator app</p>
            <p>Add account</p>
            <p>Use details below</p>
            <p style={{color: 'red', fontSize: 'small'}}>NB: We recommend QR code enrollment</p>

            <li><b>Account/Email:</b> <i>{email}</i></li>
            <li><b>Secret Key:</b> <i>{key}</i></li>
            <li><b>Issuer:</b> <i>{issuer}</i></li><br/>
            {this.renderEnrolmentTypeToggle()}
            {this.verifyAuthenticator()}
          </div>
        );
      }
    } catch (e) {
      this.setState({manualRegistration: false})
    }

    return (
      <div>
        <label>Quick QR code enrollment</label>
        <p>Launch authenticator app</p>
        <p>Add account</p>
        <p>Scan the QR Code below</p>
        <QRCodeGenerator value={this.state.qrCodeURI}/>
        {this.renderEnrolmentTypeToggle()}
        {this.verifyAuthenticator()}
      </div>
    );
  }

  verifyAuthenticator(showWarning = false) {
    const verificationSteps = !showWarning ? <div/> :
      <div>
        <p style={{color: 'red', fontSize: 15, fontWeight: 'bold'}}>Your authenticator app is not verified</p>
        <p>Launch your authenticator app</p>
        <p>Find the Yoco Admin code</p>
      </div>;

    return (
      <div style={{paddingTop: showWarning ? 0 : 20, display: 'flex', flexGrow: 1}}>
        <waffle.forms.Form
          className='default'
          showSuccessNotification={false}
          action="/api/account/authenticatorVerify"
          onSuccess={() => this.authenticatorVerified()}
        >
          {verificationSteps}
          <waffle.forms.InputField
            name='verificationCode'
            label={showWarning ? 'Put it below and click verify app' : 'Put the authenticator code below'}
            labelStyle={{fontWeight: 'normal'}}
            placeholder='2FA code'
            title='Put the code generated by your app and then click verify button below to complete the authenticator app enrollment'
            validators={[
              new waffle.forms.RequiredValidator(),
              new waffle.forms.NumberValidator(false)
            ]}/>
          <waffle.misc.FlatButton
            label='Verify App'
            type='submit'
            className='blue-background'
          />
          {this.renderResetButton()}
        </waffle.forms.Form>
      </div>
    )
  }

  renderResetButton() {
    return this.state.enrolled && !this.state.verified ? (
      <waffle.misc.FlatButton
        label='Rescan'
        type='button'
        onClick={() => this.setState({flashEnrolled: true, enrolled: false, verified: false})}
      />
    ) : <div/>
  }

  renderEnrolmentTypeToggle() {
    return this.state.enrolled ?
      <div/> :
      <p>
        <waffle.misc.FlatButton
          label={this.state.manualRegistration ? 'Scan QR code' : 'Enrol manually'}
          type='button'
          className={this.state.manualRegistration ? 'blue-background' : 'default'}
          onClick={() => this.setState({manualRegistration: !this.state.manualRegistration})}
        />
      </p>
  }

  authenticatorEnrollment() {
    if (!this.state.enrolled && !this.state.flashEnrolled) {
      return this.renderEnrollButton();
    }

    if (!this.state.verified) {
      if (!this.state.enrolled) {
        return this.renderQrCode();
      }
      return (this.verifyAuthenticator(true));
    }

    return this.renderErrorMessage();
  }

  renderErrorMessage() {
    return this.state.flashEnrolled ?
      <MoonLoader size={25}/> :
      <label style={{color: 'red', fontSize: 15, fontWeight: 'bold'}}>
        Something went wrong, if refreshing the page doesn't help, please contact the product team.
      </label>;
  }

  render() {
    if (this.state.checkingAuthStatus) {
      return <MoonLoader size={25}/>
    }
    if (!this.state.enrolled || !this.state.verified) {
      return (
        <div>
          <div className='form-header'>
            <waffle.misc.HeaderTitle title='Setup 2-Step authenticator app'/>
          </div>
          {this.authenticatorEnrollment()}
        </div>
      );
    }
    return (
      <div className="text-success" title='2 step authenticator app enrolled'>
        <span className="icon-lock" style={{position: 'relative', top: 2}}/>
        <span>{this.props.userName ? ` ${this.props.userName}` : ' Current logged-in user'}</span>
      </div>
    );
  }
}

module.exports = {
  AuthenticatorEnrollment
};
